import { Chip, useTheme } from '@mui/material'
import { GridCellParams, GridComparatorFn } from '@mui/x-data-grid-pro'

export const alertTableSeverityComparator: GridComparatorFn<DeviceAlertTableRow['severity']> = (a, b) => {
  const sortOrder = {
    urgent: 4,
    warning: 3,
    info: 2,
    unknown: 1,
  }

  if ((sortOrder[a] ?? 0) > (sortOrder[b] ?? 0)) return 1
  if ((sortOrder[a] ?? 0) < (sortOrder[b] ?? 0)) return -1
  return 0
}

const AlertTableSeverity = (cellParams: GridCellParams<DeviceAlertTableRow, DeviceAlertTableRow['severity']>) => {
  const theme = useTheme()

  const cellValue = cellParams.value ?? 'unknown'

  const { backgroundColor, textColor, ariaLabel, label } = {
    info: { backgroundColor: theme.palette.primary.shades['4p'], textColor: theme.palette.primary.main, ariaLabel: 'Info alert', label: 'Info' },
    warning: { backgroundColor: theme.palette.warning.shades['4p'], textColor: theme.palette.warning.main, ariaLabel: 'Warning alert', label: 'Warning' },
    urgent: { backgroundColor: theme.palette.error.shades['4p'], textColor: theme.palette.error.main, ariaLabel: 'Urgent alert', label: 'Urgent' },
    unknown: { backgroundColor: theme.palette.action.hover, textColor: theme.palette.text.secondary, ariaLabel: 'Unknown', label: 'Unknown' },
  }[cellValue]

  return (
    <Chip
      label={label}
      sx={{
        backgroundColor,
        color: textColor,
        width: '100%',
        maxWidth: 120,
      }}
      aria-label={ariaLabel}
    />
  )
}

export default AlertTableSeverity
